import { Text } from '@hotjar/hotsauce';
import { Trans } from 'react-i18next';
import { LoaderWrapper } from '~/trials/components/LoaderWrapper/LoaderWrapper';

interface MonthlyCostProps {
  loading: boolean;
  price?: string;
}

export const PlanMonthlyCost = ({ loading, price }: MonthlyCostProps): JSX.Element => {
  return (
    <LoaderWrapper loading={loading} delayInMS={500}>
      <Text textType="body2">
        <Trans
          i18nKey="trials:post-trial.site-list.cost-per-month"
          components={[<Text textColor="text_light" />]}
          values={{
            cost: price,
          }}
        />
      </Text>
    </LoaderWrapper>
  );
};
